import type { KeyValueStorage } from '../auth/session.js'

/**
 * Настройки рабочего места — то, что человек решил про сам портал, а не
 * про данные в нём. Сюда переезжает всё, что обязано пережить перезагрузку
 * и при этом не имеет отношения ни к арендатору, ни к серверу: свёрнутая
 * палитра сейчас, ширина колонок и открытые вкладки — когда понадобятся.
 *
 * Хранилище передаётся снаружи по той же причине, что и теме
 * (`ui/theme.ts`): `window.localStorage`, взятый изнутри, превращает любой
 * тест в тест браузера, а точка входа и так уже собирает такие хранилища
 * в одном месте (`main.tsx`).
 */
export interface WorkspaceStore {
  /** Свёрнута ли палитра нод в редакторе (FR-ADM-044). */
  палитраСвёрнута(): boolean
  свернутьПалитру(свёрнута: boolean): void
}

const КЛЮЧ_ПАЛИТРЫ = 'rk-admin.editor.palette-collapsed'

/**
 * Свёрнутость палитры хранится записью «свёрнута», а её отсутствие значит
 * «развёрнута». Ровно как у темы: два способа сказать одно и то же со
 * временем расходятся, поэтому значение по умолчанию не пишется никогда.
 *
 * Развёрнутая по умолчанию — потому что палитра и есть ответ на вопрос
 * «как сюда добавить узел». Свернуть её должен тот, кто уже знает ответ.
 */
export function createWorkspaceStore(storage: KeyValueStorage): WorkspaceStore {
  let свёрнута = storage.get(КЛЮЧ_ПАЛИТРЫ) === 'да'

  return {
    палитраСвёрнута: () => свёрнута,
    свернутьПалитру(значение: boolean) {
      свёрнута = значение
      if (значение) storage.set(КЛЮЧ_ПАЛИТРЫ, 'да')
      else storage.delete(КЛЮЧ_ПАЛИТРЫ)
    },
  }
}
